import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import AppRoutes from './routes/AppRoutes';
import Footer from './components/Footer';

function App() {
  const [currentView, setView] = useState(() => {
    const path = window.location.pathname;
    if (path.startsWith('/job-application')) return 'job-application';
    if (path.startsWith('/privacy-policy') || path.startsWith('/privacy')) return 'privacy-policy';
    if (path.startsWith('/terms-and-conditions') || path.startsWith('/terms')) return 'terms-and-conditions';
    if (path.startsWith('/social-media-marketing')) return 'social-media-marketing';
    if (path.startsWith('/seo-services')) return 'seo-services';
    if (path.startsWith('/web-development')) return 'web-development';
    if (path.startsWith('/it-services')) return 'it-services';
    if (path.startsWith('/digital-marketing')) return 'digital-marketing';
    if (path.startsWith('/ecommerce-web-development')) return 'ecommerce-web-development';
    if (path.startsWith('/web-design')) return 'web-design';
    if (path.startsWith('/logo-design')) return 'logo-design';
    if (path.startsWith('/bpo-services')) return 'bpo-services';
    if (path.startsWith('/services')) return 'services';
    if (path.startsWith('/team')) return 'team';
    if (path.startsWith('/contact')) return 'contact';
    if (path.startsWith('/careers')) return 'careers';
    if (path.startsWith('/about')) return 'about';
    if (path === '/' || path === '') return 'home';
    return '404';
  });

  useEffect(() => {
    const pageMeta = {
      'home': {
        title: 'HOME - Experts Communication',
        description: 'Leading IT & BPO Company In Pakistan. Take your business to the next level with our BPO services and IT company. We’ve been working since 2016 with a creative and innovative team that help you manage and control digital operations.'
      },
      'about': {
        title: 'About Us - Experts Communication',
        description: 'About Us Maximize Your Business Potential: Expert Solutions for the Digital Age. Helping brands and businesses with the best BPO, IT services, digital marketing, and quality web solutions since 2016.'
      },
      'services': {
        title: 'Services - Experts Communication',
        description: 'Explore comprehensive BPO, IT, Web Development, and Digital Marketing services tailored to scale your enterprise operations.'
      },
      'careers': {
        title: 'Careers - Experts Communication',
        description: 'We Do More Than Expected. Explore career opportunities at Experts Communication and take the next leap in your professional career.'
      },
      'job-application': {
        title: 'Job Application - Experts Communication',
        description: 'Apply now to join Experts Communication. Submit your resume and accelerate your professional journey.'
      },
      'contact': {
        title: 'Contact Us - Experts Communication',
        description: 'Let\'s Start Your Success Journey With Our Experts. Reach out for consultations, inquiries, and custom business solutions.'
      },
      'team': {
        title: 'Our Team - Experts Communication',
        description: 'Meet the talented leaders, developers, and operational experts driving success at Experts Communication.'
      },
      'bpo-services': {
        title: 'BPO Services - Experts Communication',
        description: 'High-performing inbound, outbound, and back-office BPO support services engineered for customer satisfaction.'
      },
      'web-development': {
        title: 'Web Development - Experts Communication',
        description: 'Custom full-stack web applications, scalable portals, and enterprise CMS development with modern technologies.'
      },
      'web-design': {
        title: 'Web Design - Experts Communication',
        description: 'Crafting responsive, high-converting, and visually immersive user interfaces for web and mobile platforms.'
      },
      'digital-marketing': {
        title: 'Digital Marketing - Experts Communication',
        description: 'Data-driven digital marketing campaigns, ROI-focused lead generation, PPC, and brand positioning.'
      },
      'seo-services': {
        title: 'SEO Services - Experts Communication',
        description: 'Comprehensive on-page, off-page, and technical SEO strategies to dominate search engine results.'
      },
      'social-media-marketing': {
        title: 'Social Media Marketing - Experts Communication',
        description: 'Engaging content creation, community management, and targeted social media growth strategies.'
      },
      'ecommerce-web-development': {
        title: 'E-Commerce Web Development - Experts Communication',
        description: 'Robust, secure, and conversion-optimized online stores built for seamless retail experiences.'
      },
      'logo-design': {
        title: 'Logo & Graphic Design - Experts Communication',
        description: 'Distinctive brand identities, logos, and visual assets crafted to make your brand memorable.'
      },
      'it-services': {
        title: 'IT Services & Infrastructure - Experts Communication',
        description: 'Managed IT services, network infrastructure, and enterprise technical support solutions.'
      },
      'privacy-policy': {
        title: 'Privacy Policy - Experts Communication',
        description: 'Learn how Experts Communication collects, safeguards, and manages user information and privacy.'
      },
      'terms-and-conditions': {
        title: 'Terms & Conditions - Experts Communication',
        description: 'Terms and conditions governing access, use, and service engagements with Experts Communication.'
      },
      '404': {
        title: '404 - Page Not Found | Experts Communication',
        description: 'The page you are looking for might have been moved, renamed, or is temporarily unavailable. Return to the Experts Communication homepage.'
      }
    };

    const currentMeta = pageMeta[currentView] || pageMeta['home'];
    document.title = currentMeta.title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', currentMeta.description);
    }
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', currentMeta.title);
    }
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) {
      ogDesc.setAttribute('content', currentMeta.description);
    }
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', currentMeta.title);
    }
    const twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (twitterDesc) {
      twitterDesc.setAttribute('content', currentMeta.description);
    }
  }, [currentView]);

  useEffect(() => {
    // Enforce trailing slash on initial page load if missing
    const initialPath = window.location.pathname;
    if (initialPath !== '/' && !initialPath.endsWith('/') && !initialPath.includes('.')) {
      window.history.replaceState({}, '', initialPath + '/' + window.location.search + window.location.hash);
    }

    const handlePopState = () => {
      const path = window.location.pathname;
      if (path !== '/' && !path.endsWith('/') && !path.includes('.')) {
        window.history.replaceState({}, '', path + '/' + window.location.search + window.location.hash);
      }

      if (path.startsWith('/job-application')) setView('job-application');
      else if (path.startsWith('/privacy-policy') || path.startsWith('/privacy')) setView('privacy-policy');
      else if (path.startsWith('/terms-and-conditions') || path.startsWith('/terms')) setView('terms-and-conditions');
      else if (path.startsWith('/social-media-marketing')) setView('social-media-marketing');
      else if (path.startsWith('/seo-services')) setView('seo-services');
      else if (path.startsWith('/web-development')) setView('web-development');
      else if (path.startsWith('/it-services')) setView('it-services');
      else if (path.startsWith('/digital-marketing')) setView('digital-marketing');
      else if (path.startsWith('/ecommerce-web-development')) setView('ecommerce-web-development');
      else if (path.startsWith('/web-design')) setView('web-design');
      else if (path.startsWith('/logo-design')) setView('logo-design');
      else if (path.startsWith('/bpo-services')) setView('bpo-services');
      else if (path.startsWith('/services')) setView('services');
      else if (path.startsWith('/team')) setView('team');
      else if (path.startsWith('/contact')) setView('contact');
      else if (path.startsWith('/careers')) setView('careers');
      else if (path.startsWith('/about')) setView('about');
      else if (path === '/' || path === '') setView('home');
      else setView('404');
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigateTo = (view) => {
    let path = '/';
    if (view === 'job-application') path = '/job-application/';
    else if (view === 'privacy-policy') path = '/privacy-policy/';
    else if (view === 'terms-and-conditions') path = '/terms-and-conditions/';
    else if (view === 'social-media-marketing') path = '/social-media-marketing/';
    else if (view === 'seo-services') path = '/seo-services/';
    else if (view === 'web-development') path = '/web-development/';
    else if (view === 'it-services') path = '/it-services/';
    else if (view === 'digital-marketing') path = '/digital-marketing/';
    else if (view === 'ecommerce-web-development') path = '/ecommerce-web-development/';
    else if (view === 'web-design') path = '/web-design/';
    else if (view === 'logo-design') path = '/logo-design/';
    else if (view === 'bpo-services') path = '/bpo-services/';
    else if (view === 'services') path = '/services/';
    else if (view === 'team') path = '/team/';
    else if (view === 'contact') path = '/contact/';
    else if (view === 'careers') path = '/careers/';
    else if (view === 'about') path = '/about/';
    else if (view === '404') path = '/404/';

    if (window.location.pathname !== path) {
      window.history.pushState({}, '', path);
    }
    setView(view);
  };

  return (
    <div className="App">
      <Header currentView={currentView} setView={navigateTo} />
      <AppRoutes currentView={currentView} setView={navigateTo} />
      <Footer setView={navigateTo} />
    </div>
  );
}

export default App;
